"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = void 0;
const _1 = require(".");
async function composeParams(params, almanac) {
    const evaluatedParams = {};
    for (const [key, value] of Object.entries(params)) {
        if (value && typeof value === 'object') {
            if ('fact' in value && value.fact) {
                evaluatedParams[key] = await almanac.factValue(value.fact, value.params, value.path);
            }
            else {
                evaluatedParams[key] = await composeParams(value, almanac);
            }
        }
        else {
            evaluatedParams[key] = value;
        }
    }
    return evaluatedParams;
}
async function api(params, almanac) {
    if (params.url) {
        let url;
        if (typeof params.url !== 'string') {
            url = params.url.template;
            for (const [key, value] of Object.entries(params.url.variables)) {
                const stringValue = typeof value === 'string' ? value : await almanac.factValue(value.fact, value.params, value.path);
                url = url.replace(`{${key}}`, stringValue);
            }
        }
        else {
            url = params.url;
        }
        const queryParams = params.queryParams ? await composeParams(params.queryParams, almanac) : {};
        return await almanac.factValue((0, _1.internalFact)('axios'), {
            url,
            queryParams,
        });
    }
    return null;
}
exports.api = api;
//# sourceMappingURL=api-fact.js.map